<ion-grid>
	<form [formGroup]="editForm" (ngSubmit)="onSubmit(editForm)">
		<ion-row class="background-Blues-Light_Blue_3 pt-24">
			<ion-col class="top-box my-10 mx-16">
				<div class="flex">
					<ion-icon
						name="close-outline"
						class="close-icon"
						(click)="close()"
					></ion-icon>
					<span class="Body_M color-Blacks-Default_Black">{{ formTitle }}</span>
				</div>
				<ion-button class="Small-button-Active_primary_with_icon" type="submit">
					Done
					<ion-spinner *ngIf="isLoading"></ion-spinner>
					<ion-icon name="checkmark-outline" *ngIf="!isLoading"></ion-icon>
				</ion-button>
			</ion-col>
		</ion-row>
		<ion-row class="p-16 row-gap-16 Body_M">
			<ng-container *ngFor="let formField of form">
				<ion-col
					size="{{ formField.size || 12 }}"
					*ngIf="formField.type !== 'hidden'"
				>
					<ion-grid>
						<ion-row>
							<ion-col size="12" class="pb-8 align-middle">
								{{ formField.title }}
								<span
									*ngIf="formField.isCopy"
									class="align-middle cursor-pointer"
									title="Copy"
									(click)="copyUrl(editForm.value[formField.formControlName])"
									><ion-icon name="clipboard-outline"></ion-icon
								></span>
							</ion-col>
						</ion-row>
						<ion-row
							[class.Elevation-1_Flat]="
								!(
									formField.type === 'image' || formField.type === 'text-editor'
								)
							"
						>
							<ion-col size="12">
								<ng-container [ngSwitch]="formField.type">
									<ng-container *ngSwitchCase="'toggle'">
										<ion-toggle
											[formControlName]="formField.formControlName"
										></ion-toggle>
									</ng-container>
									<ng-container *ngSwitchCase="'select'">
										<ng-select
											[formControlName]="formField.formControlName"
											[multiple]="multiValueSelect[formField.formControlName]"
											[placeholder]="formField.placeholder"
											[readonly]="isUpdate"
											[virtualScroll]="true"
											*ngIf="formField.formControlName !== 'partnershipCompany'"
										>
											<ng-option
												*ngFor="
													let item of selectOptions[formField.formControlName]
												"
												[value]="item.id"
												>{{ item.name }}</ng-option
											>
										</ng-select>
										<ng-select
											[formControlName]="formField.formControlName"
											[multiple]="multiValueSelect[formField.formControlName]"
											[placeholder]="formField.placeholder"
											[readonly]="isUpdate"
											[virtualScroll]="true"
											(scrollToEnd)="onScroll($event)"
											(search)="searchCompany($event)"
											(clear)="onClear($event)"
											*ngIf="formField.formControlName === 'partnershipCompany'"
										>
											<ng-option
												*ngFor="let item of options"
												[value]="item.id"
												>{{ item.name }}</ng-option
											>
										</ng-select>
									</ng-container>
									<ng-container *ngSwitchCase="'datetime-local'">
										<ion-input
											type="text"
											class="input"
											[placeholder]="formField.placeholder"
											[formControlName]="formField.formControlName"
											mbsc-datepicker
											[controls]="['date', 'time']"
											dateFormat="DD/MM/YYYY"
											[buttons]="['set', 'cancel']"
											timeFormat="hh:mm A"
										></ion-input>

										<!-- <mbsc-datepicker
											[formControlName]="formField.formControlName"
										>
										</mbsc-datepicker> -->
									</ng-container>

									<ng-container *ngSwitchCase="'text-editor'">
										<ion-row>
											<ion-col size="12">
												<div>
													<quill-editor
														class="text-editor"
														formControlName="{{ formField.formControlName }}"
													></quill-editor>
												</div>
											</ion-col>
										</ion-row>
									</ng-container>
									<ng-container *ngSwitchDefault>
										<ion-input
											[type]="formField.type"
											class="input"
											[placeholder]="formField.placeholder"
											[formControlName]="formField.formControlName"
											[readonly]="formField.disabled"
											[class.disabled]="formField.disabled"
										></ion-input>
									</ng-container>
								</ng-container>

								<ng-container *ngFor="let validation of formField.errorsMsg">
									<div
										class="errorMessageClass flex items-center mb-12 ml-12"
										*ngIf="
											editForm
												.get(formField.formControlName)
												?.hasError(validation.type) &&
											(editForm.get(formField.formControlName)?.dirty ||
												editForm.get(formField.formControlName)?.touched)
										"
									>
										<ion-icon
											name="close-circle"
											class="text-rose-600"
										></ion-icon>
										<span class="text-rose-600 ml-8 mt-2">{{
											validation.message
										}}</span>
									</div>
								</ng-container>
							</ion-col>
						</ion-row>
					</ion-grid>
				</ion-col>
			</ng-container>
		</ion-row>
	</form>
</ion-grid>
